import styled from "styled-components";

export const VehicleActionContainer = styled.div``;

export const DescriptionVehicleAction = styled.h3`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin: 0;
`;

export const VehiclePlate = styled.span`
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;
